export interface Observer {
    notify(data: NotificationData): void;
    remove(): void;
}

export interface NotificationData {
    status?: string;
    actionHandler?(): void;
}

export default class Notifier {
    protected observersCollection: Observer[] = [];

    registerObserver(obs: Observer) {
        this.observersCollection.push(obs);
    }

    unregisterObserver(obs: Observer) {
        let idx = this.observersCollection.indexOf(obs);
        if (idx === -1) {
            return;
        }
        this.observersCollection.splice(idx, 1);
    }

    notify(data: NotificationData) {
        for (let i = 0; i < this.observersCollection.length; i++) {
            this.observersCollection[i].notify(data);
        }
    }

    remove() {
        for (let i = 0; i < this.observersCollection.length; i++) {
            this.observersCollection[i].remove();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/Notifier.ts
 **/